const navigationMenu = {
  'USERS': 'Utilisateurs',
  'ROLES': 'Rôles',
  'SECURITY': 'Sécurité',
  'Dealer Request': "Demande d'inscription installateur",
  'CONTROLLER_OPTION': 'Contrôleur',
  'HOLIDAY_OPTION': 'Congés',
  'SCHEDULE_OPTION': 'Horaire',
  'ACCESSLEVEL_OPTION': "Niveau d'accès",
  'GLOBALSETTINGS_OPTION': 'Paramètres globaux',
  'EVENT_OPTION': 'Événements',
  'ACCOUNT_INFO': 'Info du compte',
  'LOCKDOWN_OPTION': 'Confinement',
  'FLOOR_PLAN_OPTION': "Plan d'étage",
  'HARDWARE': 'Matériel',
  'SETTINGS': 'Paramètres',
  'Input': 'Entrée',
  'Output': 'Sortie',
  'firmware_manager': 'Gestionnaire de micrologiciel',
  'Events': "Rapport d'événements",
  'INTERLOCK_OPTION': 'Sas',
  'CDVI_HELP_CONFIGURATION': "Configuration de l'aide",
  'banner_configuration': 'Configuration de la bannière',
  'STRIPE': 'Stripe',
  'menu': {
    home: 'Accueil',
    diagnose_controller: 'Diagnostiquer le contrôleur',
    new_session: 'Nouvelle session',
    open_sessions: 'Sessions ouvertes',
    current_session: 'Session actuelle',
    dealers: 'Installateurs',
    dealer_requests: 'Demandes d’inscription installateur',
    accounts: 'Comptes',
    help_configuration: "Configuration de l'aide",
    stripe: 'Stripe',
    stripe_sync_issues: 'Problèmes de synchronisation Stripe',
    account_info: 'Info compte',
    credentials: 'Identifiants',
    doors: 'Portes',
    events: 'Événements',
    global_settings: 'Paramètres globaux',
    hardware: 'Matériel',
    controllers: 'Contrôleurs',
    outputs: 'Sorties',
    firmwares: 'Micrologiciels',
    notifications: 'Notifications',
    users: 'Utilisateurs',
    settings: 'Paramètres',
    holidays: 'Congés',
    schedules: 'Horaires',
    access_levels: "Niveaux d'accès",
    lockdown: 'Confinement',
    floor_plans: "Plans d'étage",
    interlocks: 'Sas',
    sites: 'Sites',
    site_info: 'Info du site',
    firmware_manager: 'Gestionnaire de micrologiciel',
    testing_tool: 'Outil de test',
    tasks: 'Tâches',
    anti_passback: 'Anti-passback',
  },
  'config': {
    profile: 'Profil',
    dealer_info: "Informations de l'installateur",
    logout: 'Se déconnecter',
    change_password: 'Changer le mot de passe',
    switch_profile: 'Changer de profil',
    language: 'Langue',
  },
  'switch': {
    welcome: 'Bienvenue <1>{{ name }}</1>,',
    explanation:
      'Plusieurs profils sont associés à votre utilisateur. Vous pouvez passer de l’un à l’autre à tout moment ici :',
    name: 'Nom',
    last_login: 'Dernière connexion',
    actions: 'Actions',
    login: 'Connexion',
    active_profile: 'Profil actif',
    as_dealer: 'Comme marchand',
    as_organization: 'Comme organisation',
    as_system: 'Comme système',
  },
  'version': {
    label: 'Version',
    copied: 'Copié!',
  },
  'section_customer_support': 'Support client',
  'section_administration': 'Administration',
  'section_account': 'Compte',
  'section_technical_support': 'Support technique',
  'change_password_instruction_1':
    "Pour changer votre mot de passe, veuillez d'abord vous déconnecter.",
  'change_password_instruction_2':
    "Sur l'écran de connexion, attendez que l'option « Mot de passe oublié? » apparaisse, puis cliquez dessus et suivez les instructions pour réinitialiser votre mot de passe.",
};

export default navigationMenu;
